module.exports = __webpack_public_path__ + "static/media/books-medical.7a8741a4.svg";